import * as Yup from 'yup';

const schema = Yup.object().shape({
  ordem: Yup.number().required('O campo ordem é obrigatório.'),
  texto_ajuda: Yup.string().required('O campo texto ajuda é obrigatório.'),
  titulo: Yup.string().required('O campo título é obrigatório.'),
  tamanho_maximo_caracteres: Yup.number()
    .integer('O tamanho máximo deve ser um número inteiro.')
    .positive('O tamanho máximo deve ser um número positivo.')
    .nullable()
    .notRequired(),
});

export { schema };
